import { msg } from "@lingui/core/macro";

export const preflightDateTimeParseRuleMessages = {
	errors: {
		invalidDateTime: msg({ message: "Invalid Date Time ({date})" }),
	},
} as const;
